import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

import Store from '@/store';

import config from '@/constant/config'

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
	return VueRouterReplace.call(this, to).catch(err => err)
}

import { menuList } from '@/constant/menuConfig'

const router = new VueRouter({
	routes: [{
			path: '/',
			name: 'Index',
			redirect: '/home',
			component: () => import('@/views/index.vue'),
			children: [{
					path: '/index',
					name: 'Index',
					redirect: '/home',
					component: () => import('@/views/layout.vue'),
					children: [{
						path: '/home',
						name: 'Home',
						component: () => import('@/views/pages/home.vue'),
					}, {
						path: '/vip',
						name: 'VIP',
						component: () => import('@/views/pages/vip/index.vue'),
						/* meta: {
							unRequiresAuth: true // 不需要登录权限
						}, */
					}, {
						path: '/user',
						name: 'UserCenter',
						redirect: '/user/zhanghao',
						component: () => import('@/views/pages/user/index.vue'),
						children: [{
							path: 'zhanghao',
							name: 'Zhanghao',
							component: () => import('@/views/pages/user/zhanghao.vue')
						}, {
							path: 'dingdan',
							name: 'Dingdan',
							component: () => import('@/views/pages/user/dingdan.vue')
						}, {
							path: 'vipProducts',
							name: 'VipProducts',
							component: () => import('@/views/pages/user/vipProducts.vue')
						}, {
							path: 'task_reward',
							name: 'TaskReward',
							component: () => import('@/views/pages/user/task_reward.vue')
						}, {
							path: 'exchange',
							name: 'Exchange',
							component: () => import('@/views/pages/user/exchange.vue')
						}]
					}, {
						path: '/serviceAgreement',
						name: 'ServiceAgreement',
						component: () => import('@/views/pages/vip/serviceAgreement.vue')
					}, {
						path: '/share',
						name: 'Share',
						component: () => import('@/views/pages/vip/share.vue'),
					}, {
						path: '/bibDoc',
						name: 'BibDoc',
						component: () => import('@/views/pages/bibDoc.vue'),
					}, {
						path: '/imgMan',
						name: 'ImgMan',
						component: () => import('@/views/pages/proDesc/imgMan.vue'),
					}, {
						path: '/aibsDesc',
						name: 'AibsDesc',
                        component: () => import('@/views/pages/proDesc/aibsDesc.vue'),
					}, {
						path: '/aicheckDesc',
						name: 'AicheckDesc',
						component: () => import('@/views/pages/proDesc/aicheckDesc.vue'),
					}, {
						path: '/aijsDesc',
						name: 'AijsDesc',
						component: () => import('@/views/pages/proDesc/aijsDesc.vue'),
					}, {
						path: '/aizsDesc',
						name: 'AizsDesc',
						component: () => import('@/views/pages/proDesc/aizsDesc.vue'),
					}, {
						path: '/ktbDesc',
						name: 'KtbDesc',
						component: () => import('@/views/pages/proDesc/ktbDesc.vue'),
					}, {
						path: '/bibDocDesc',
						name: 'BibDocDesc',
						component: () => import('@/views/pages/proDesc/bibDocDesc.vue'),
					}]
				},
				{
					path: '/feedback',
					name: 'Feedback',
					component: () => import('@/views/pages/notHead/feedback.vue'),
				},
				{
					path: '/noPermissionAnddueDate',   // 无权限和到期
					name: 'NoPermissionAnddueDate',
					component: () => import('@/views/noPermissionAnddueDate.vue'),
				},
				{   // 后台管理
					path: '/admin',
					name: 'Admin',
					component: () => import('@/views/admin/index.vue'),
					redirect: '/admin/unitNum',
					children: [
						...menuList
					]
				},
			]
		},
		{
			path: '/404',
			component: () => import('@/views/404.vue'),
			meta: {
				unRequiresAuth: true // 不需要登录权限
			},
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
})

// 路由跳转前
router.beforeEach(async (to, from, next) => {
	// 设置页面标题
	if (to.path.startsWith('/admin')) {
		// 后台管理页面
		document.title = to.meta.title ? `${to.meta.title}` : config.adminItemNmae
	} else {
		document.title = to.meta.title ? `${to.meta.title}` : config.itemName
	}

	// 存储 URL 中的 token 参数
	if (to.query.token) {
		sessionStorage.setItem('token', to.query.token)
		// 清理 URL 中的 token 参数
		if (to.path === '/noPermissionAnddueDate') {
			return next({ path: '/home', replace: true })
		}
		const query = { ...to.query }
		delete query.token
		return next({ path: to.path, query, replace: true })
	}

	// 如果路由不需要认证，直接放行
	if (to.meta.unRequiresAuth) {
		return next();
	}

	// 需要登录的页面
	// const requiresAuth = to.meta.requiresAuth || ['UserCenter'].includes(to.name)
	// 不需要登录但可以查看的页面
	const notLoginPage = to.name === 'Home' || to.path === '/' || to.path === '/home' || to.path === '/vip'

	try {
		if (!Store.state.userInfo) {
			await Store.dispatch('fetchUserInfo');
		}
		next();
	} catch (error) {
		console.log('获取用户信息失败:', error);
		// 未登录时，跳转到首页
		if (!notLoginPage) {
			next('/home')
		} else {
			next();
		}
	}
})

// 路由跳转后
router.afterEach((to, from) => {
	window.scrollTo(0, 0) // 每次路由改变滚动条都回到顶部
})

export default router
